module.exports = __webpack_public_path__ + "static/media/medalWrong.186f00f1.png";